export default __webpack_public_path__ + "static/media/PotentialPerformance.31a6111b.png";